import { render, staticRenderFns } from "./RegisterFormMoovaForm.vue?vue&type=template&id=51da2977"
import script from "./RegisterFormMoovaForm.vue?vue&type=script&lang=js"
export * from "./RegisterFormMoovaForm.vue?vue&type=script&lang=js"
import style0 from "./RegisterFormMoovaForm.vue?vue&type=style&index=0&id=51da2977&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports